import { type FormEvent, useId, useState } from 'react'
import { httpStatus, NICKNAME_PATTERN, normalizeNickname } from './client'

interface Props {
  label: string
  submitLabel: string
  initial?: string
  onSubmit: (nickname: string) => Promise<void>
}

const RULES = 'От 2 до 20 символов: буквы, цифры, пробел, «_.-»'

export default function NicknameForm({ label, submitLabel, initial = '', onSubmit }: Props) {
  const inputId = useId()
  const [value, setValue] = useState(initial)
  const [error, setError] = useState<string | null>(null)
  const [pending, setPending] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    const nickname = normalizeNickname(value)
    if (!NICKNAME_PATTERN.test(nickname)) {
      setError(RULES)
      return
    }
    setPending(true)
    setError(null)
    try {
      await onSubmit(nickname)
    } catch (err) {
      const status = httpStatus(err)
      setError(
        status === 422
          ? RULES
          : status === 429
            ? 'Слишком часто — попробуйте через минуту'
            : 'Нет связи с сервером — попробуйте позже',
      )
    } finally {
      setPending(false)
    }
  }

  return (
    <form className="nickname" onSubmit={submit} noValidate>
      <label className="nickname__label" htmlFor={inputId}>
        {label}
      </label>
      <div className="nickname__row">
        <input
          id={inputId}
          className="nickname__input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          maxLength={20}
          autoComplete="nickname"
          enterKeyHint="done"
          aria-invalid={error !== null}
          aria-describedby={error ? `${inputId}-error` : undefined}
        />
        <button type="submit" className="nickname__submit" disabled={pending}>
          {submitLabel}
        </button>
      </div>
      {error && (
        <p id={`${inputId}-error`} className="nickname__error" role="alert">
          {error}
        </p>
      )}
    </form>
  )
}
